var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{attrs:{"title":_vm.actualTime}},[_vm._v(_vm._s(_vm.relativeTime))])}
var staticRenderFns = []

export { render, staticRenderFns }